import { VariablesCacheStorageInterface, CaseID, CaseCacheDTO, Stringifier } from '@dandelion/core';
import { inject, injectable } from 'inversify';
import { YearService } from "../services/YearService";
import { NamedServices } from '../enum/NamedServices';

const cacheStringifier = new Stringifier<Map<CaseID, CaseCacheDTO>>();
@injectable()
export class InMemoryCacheStorageByYear implements VariablesCacheStorageInterface {

  protected cachedCases: Map<string, Map<string, CaseCacheDTO>> = new Map();

  constructor(
    @inject(NamedServices.YearService) private yearService: YearService,
  ) {
  }

  getCachedCases(): Map<string, CaseCacheDTO> {
    const centreCode = this.yearService.getCentreCodeWithSelectedYear().value;
    const previousYearCentreCode = this.yearService.getCentreCodeWithPreviousYear().value;
    const currentYearCache = this.cachedCases.get(`cachedCases_${centreCode}`) ?? new Map();


    if (!previousYearCentreCode) {
      return currentYearCache;
    }

    const previousYearCache = this.cachedCases.get(`cachedCases_${previousYearCentreCode}`) ?? new Map();
    const combinedCache = new Map<string, CaseCacheDTO>([...currentYearCache, ...previousYearCache]);

    return combinedCache;
  }

  overwriteCache(cache: Map<string, CaseCacheDTO>): void {
    const centreCodeWithYear = this.yearService.getCentreCodeWithSelectedYear().value;
    const year = parseInt(centreCodeWithYear.split('_')[1], 10);

    if (isNaN(year)) {
      throw new Error('Invalid year in centreCode');
    };

    // Initialize a map to store cache by year
    const cacheByYear = new Map<number, Map<string, CaseCacheDTO>>();
    cache.forEach((value, key) => {
      const icuAdmDateString = value.variables.get("core.administrativeInfo.icuAdmDate") as string;
      const icuAdmDate = new Date(icuAdmDateString);
      const caseYear = icuAdmDate.getFullYear();

      if (!isNaN(caseYear)) {
        let yearMap = cacheByYear.get(caseYear);
        if (!yearMap) {
          yearMap = new Map<string, CaseCacheDTO>();
          cacheByYear.set(caseYear, yearMap);
        }
        yearMap.set(key, value);
      }
    });
    cacheByYear.forEach((yearMap, yearKey) => {
      const centreCodeForYear = `${centreCodeWithYear.split('_')[0]}_${yearKey}`;
      this.cachedCases.set(`cachedCases_${centreCodeForYear}`, yearMap);
    });
  }

}
